import React from "react";
import { connect } from "react-redux";
import { Card, CardBody, CardGroup, Col, Container, Row } from "reactstrap";
import queryString from "query-string";
import { autologinLexOffice } from "../../../user/services/store/user.actions";
import AlertComponent from "../../../_UI/Components/Alerts/AlertComponent";
import { logout } from "../../../user/services/store/authentication.actions";
import LoadingSpinner from "../../../_UI/Components/LoadingSpinner";

class LexOfficeAutoLogin extends React.Component {
    constructor(props) {
        super(props);

        // reset LexOfficeAutoLogin status
        this.props.dispatch(logout());

        let params = queryString.parse(this.props.location.search);
        this.state = {
            urlParams: params,
        };

        if (params && params.code && params.id) {
            this.props.dispatch(autologinLexOffice(params.id, params.code));
        } else {
            this.state = {
                errorMessage: "Einloggen nicht möglich. Versuche gegebenenfalls eine Neuauthentifizierung.",
            };
        }
    }

    componentDidMount() {}

    render() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6" xs="12">
                            <CardGroup>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col xs="12" className="justify-content-center">
                                                <img
                                                    src={process.env.PUBLIC_URL + "/logo.png"}
                                                    alt="Pathway Logo"
                                                    style={{ maxWidth: "60%" }}
                                                    className="rounded mx-auto d-block"
                                                />
                                                <br />
                                                <br />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <AlertComponent
                                                    errorMessages={this.props.userRegistration.errorMessage}
                                                />
                                                <AlertComponent errorMessages={this.state.errorMessage} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <LoadingSpinner
                                                    loading={
                                                        this.props.userRegistration.loginLoading ||
                                                        this.props.userRegistration.autologinSuccess
                                                    }
                                                    size="4rem"
                                                />
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </CardGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    const { authentication, userRegistration } = state;
    return {
        loggingIn,
        authentication,
        userRegistration,
    };
}

export default connect(mapStateToProps)(LexOfficeAutoLogin);
